export default {
  encodeJSON(myJson) {
    var encodedJSON = new URLSearchParams();
    for (let key in myJson) {
      encodedJSON.append(key, myJson[key]);
    }
    return encodedJSON;
  }
}